module.exports = __webpack_public_path__ + "img/khal_img06.6ee81d3a.svg";